<template>
  <div id="companion">
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムトーーーク☆」">
      <ul>
        <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <SubHeader/>
    <div class="top">
    <p class="subTitle-row">コンパニオン一覧</p>
    </div>
    <div class="flexbox" id="c">
    </div>
  </div>
</template>
<style>
#companion .item {
   background-color: white;
   box-shadow: 4px 4px #006600;
   margin: 5px;
   margin-top: 16px;
  width: 20%;
  text-align: center;
  position: relative;
}
.top{
  padding-top: 0px;
}
#companion .item:hover {
  transform: translateY(-0.1875em);
}
#companion .flexbox img {
  width: 100%;
  height: 300px;
  object-fit: cover;
}
#companion p {
  text-align: center;
  font-weight: bold;
  color: #555555;
}
.subTitle-row{
 background-image: url(../assets/bg-title.jpg);
background-size:cover;
  height: 50px;
  line-height: 50px;
 color:white;
 box-shadow: 4px 4px #005FFF;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 5px 5px 5px 5px;
  font-weight: bold;
  border: 5px solid  white;
}
#companion .flexbox a {
  display: contents;
  text-decoration: none;
}
.biginer-img{
  position: absolute;
  z-index: 5000;
  bottom:20%;
  right: 8px;
  width: 48px!important;
  height: 56px!important;
}
/* Responsive */
@media ( min-width : 600px ){
    #companion .flexbox {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 70%;
    margin: 0 auto;
    justify-content: space-between;
    }
  #companion .item {
    width: 20%;
  }
}
#sm-menu{
  background-color:rgba(0,0,0,0.9);
  display: none;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
#close{
display: block;
position: absolute;
width: 64px;
height:64px;
top:16px;
right:16px;
}
.rank-img {
  position: absolute;
  z-index: 5000;
  top:8px!important;
  left: 8px;
  width: 48px!important;
  height: 48px!important;
}
@media ( max-width : 680px ){
  .rank-img {
  position: absolute;
  z-index: 5000;
  top:8px!important;
  left: 8px;
  width: 36px!important;
  height: 36px!important;
}
   .subTitle-row{
  margin:0px auto;
}
.top{
  padding-top: 100px;
}
 a{
    color: #555555!important;
   font-weight: bold;
  text-decoration: none;
  font-size:24px;
}
   #sm-menu li{
    display: block;
   background-image: url(../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  li a{
   color: white;
  text-decoration: none;
  font-size:24px;
  line-height:70px;
}
  #sm-menu ul{
    margin-top: 100px;
     color: #555555!important;
     padding:inherit;

  }
  .subTitle-row{
    width: 90%;
  }
  #companion .item {
  background-color: white;
  margin: 16px auto;
  width: 40%;
  text-align: center;
}
#companion .flexbox {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
    }
   #companion .flexbox img {
  height: 250px;

}
.biginer-img{
  position: absolute;
  z-index: 5000;
  bottom:25%;
  right: 8px;
  width: 24px!important;
  height: 36px!important;
}

}
#companion p {
    font-size: initial;
    font-weight: 700;
}
.subTitle-row{
  color: white!important;
  box-shadow: 4px 4px #555555;
}
@media ( min-width : 1800px ){
  #companion .flexbox img {
   height: 400px;

}
.rank-img {
  position: absolute;
  z-index: 5000;
  top:8px!important;
  left: 8px;
  width: 64px!important;
  height: 64px!important;
}
}
</style>
<script>
import SubHeader from './common/SubHeader'
import firebase from 'firebase'
export default {
  name: 'app',
  components: {
    SubHeader
  },
  created: function () {
    this.db = firebase.firestore()
    let collection = this.db.collection('companions').orderBy('rank', 'asc')
    collection.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
         if (doc.data().isRelease) {
        var a = document.createElement('a')
        a.href = '/companion/detail?id=' + doc.id
        var div = document.createElement('div')
        div.className = 'item'
        var img = document.createElement('img')
        img.src = doc.data().thumbnail
        div.appendChild(img)
        var p = document.createElement('p')
        p.innerHTML = doc.data().name + '(' + doc.data().age + ')'
        div.appendChild(p)
        if (doc.data().isBiginer) {
          var biginer = document.createElement('img')
          biginer.className = 'biginer-img'
          biginer.src = 'https://kei-corporation.jp/wp-content/uploads/2020/05/biginer.png'
          div.appendChild(biginer)
        }
        if (doc.data().rank === 1) {
          var rank1 = document.createElement('img')
          rank1.className = 'rank-img'
          rank1.src = 'https://kei-corporation.jp/wp-content/uploads/2020/05/rank1.png'
          div.appendChild(rank1)
        }
        if (doc.data().rank === 2) {
          var rank2 = document.createElement('img')
          rank2.className = 'rank-img'
          rank2.src = 'https://kei-corporation.jp/wp-content/uploads/2020/05/rank2.png'
          div.appendChild(rank2)
        }
        if (doc.data().rank === 3) {
          var rank3 = document.createElement('img')
          rank3.className = 'rank-img'
          rank3.src = 'https://kei-corporation.jp/wp-content/uploads/2020/05/rank3.png'
          div.appendChild(rank3)
        }
        a.appendChild(div)
        document.getElementById('c').appendChild(a)
      }
      })
    })
  },
  mounted: function () {
  },
  methods: {
    closeMenu: function () {
      document.getElementById('sm-menu').style.display = 'none'
      document.getElementById('sm-menu-icon').style.display = 'block'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Companion.vue